// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file sales/list_sales.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Sale, SaleStatus, SalesUsers } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListSalesRequest
 */
export class ListSalesRequest extends Message<ListSalesRequest> {
  /**
   * Optional: Filter sales by patient ID
   *
   * @generated from field: string patient_id = 1;
   */
  patientId = "";

  /**
   * Optional: Search query to filter sales by receipt number or other criteria
   *
   * @generated from field: string search_query = 2;
   */
  searchQuery = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 3;
   */
  page = 0;

  /**
   * Number of sales per page
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize = 0;

  /**
   * Optional: Filter sales by status (e.g., completed, pending)
   *
   * @generated from field: com.neulink.pharmacy.SaleStatus status = 5;
   */
  status = SaleStatus.UNSPECIFIED;

  /**
   * Optional: Start date for filtering sales (timestamp)
   *
   * @generated from field: int32 start_date = 6;
   */
  startDate = 0;

  /**
   * Optional: End date for filtering sales (timestamp)
   *
   * @generated from field: int32 end_date = 7;
   */
  endDate = 0;

  /**
   * Optional: Filter sales by user ID who created the sale
   *
   * @generated from field: int32 created_by = 8;
   */
  createdBy = 0;

  constructor(data?: PartialMessage<ListSalesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListSalesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "search_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(SaleStatus) },
    { no: 6, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "created_by", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSalesRequest {
    return new ListSalesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSalesRequest {
    return new ListSalesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSalesRequest {
    return new ListSalesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSalesRequest | PlainMessage<ListSalesRequest> | undefined, b: ListSalesRequest | PlainMessage<ListSalesRequest> | undefined): boolean {
    return proto3.util.equals(ListSalesRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListSalesResponse
 */
export class ListSalesResponse extends Message<ListSalesResponse> {
  /**
   * List of sales matching the request criteria
   *
   * @generated from field: repeated com.neulink.pharmacy.Sale sales = 1;
   */
  sales: Sale[] = [];

  /**
   * List of users associated with the sales
   *
   * @generated from field: repeated com.neulink.pharmacy.SalesUsers users = 2;
   */
  users: SalesUsers[] = [];

  /**
   * Total number of sales matching the request criteria
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListSalesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListSalesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sales", kind: "message", T: Sale, repeated: true },
    { no: 2, name: "users", kind: "message", T: SalesUsers, repeated: true },
    { no: 3, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSalesResponse {
    return new ListSalesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSalesResponse {
    return new ListSalesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSalesResponse {
    return new ListSalesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSalesResponse | PlainMessage<ListSalesResponse> | undefined, b: ListSalesResponse | PlainMessage<ListSalesResponse> | undefined): boolean {
    return proto3.util.equals(ListSalesResponse, a, b);
  }
}

